import { create } from 'zustand';

/**
 * Estados globais dos drawers de ficha de Originadora e Pessoa (aba Originação). Guardam só o id;
 * a ficha (dados + métricas + deals) é buscada por GET dentro do drawer. Globais (zustand) —
 * espelham dealDrawerStore/investmentDrawerStore — porque o clique vem do ranking, da busca global
 * ou de outra ficha.
 */
interface OriginadoraDrawerState {
  id: string | null;
  openOriginadora: (id: string) => void;
  close: () => void;
}

export const useOriginadoraDrawer = create<OriginadoraDrawerState>()((set) => ({
  id: null,
  openOriginadora: (id) => set({ id }),
  close: () => set({ id: null }),
}));

interface PersonDrawerState {
  id: string | null;
  openPerson: (id: string) => void;
  close: () => void;
}

export const usePersonDrawer = create<PersonDrawerState>()((set) => ({
  id: null,
  openPerson: (id) => set({ id }),
  close: () => set({ id: null }),
}));
